import type {ColumnFragment, ValueFragment} from "app/gql/graphqlSchema";
import {EmptyValue} from "app/employee/controlCard/display/EmptyValue";
import {InvalidValue} from "app/employee/controlCard/display/InvalidValue";
import {TimeDisplay} from "app/employee/TimeDisplay";

interface Props {
  column: ColumnFragment & {__typename: "ControlCardTimeColumn"};
  value: ValueFragment;
}
export const DisplayTime = ({value}: Props) => {
  let result: JSX.Element;
  if (value.__typename === "ControlCardTimeValue") {
    result = <TimeDisplay time={value.time} />;
  } else if (value.__typename === "ControlCardEmptyValue") {
    result = <EmptyValue />;
  } else {
    result = <InvalidValue />;
  }

  return result;
};
